<template>
    <div class="container">


        <!-- <div class="btn-close" @click="closeMoreInfo" v-if="showIFrameCloseBtn">返回</div> -->
       
        <!-- <div :class="!isShowTips ? 'circle-box' : 'circle-box move-up'">
            <div class="circle-box-bg">
                以下是科普，不代表产品<br />
                实际功效，请理性阅读
            </div>

        </div>
        <div  :class="!isShowTips ? 'btn-box' : 'btn-box btn-show'">
            <div class="btn-weixin" ref="btn">
                <div class="" id="launch-btn">
                    <div class="placeholder">
                        <div class="btn-wrapper">
                            <span>开始测试</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div :class="!isShowTips ? 'circle-box' : 'circle-box move-up'" >
            <div class="circle-box-img" >
                <div class="circle-box-bg" v-show="isShowChange">
                    <div style="width: 70vw; text-align: center;">以下是科普，不代表产品<br />
                        实际功效，请理性阅读
                        <div class="" style="display: flex; margin-top: 20px; width: 70vw; justify-content: center;">
                            <div class="btn-weixin-2" ref="btn" v-show="isShowChange">
                                <div class="" id="launch-btn">
                                    <div class="placeholder">
                                        <div class="btn-wrapper">
                                            <span style="color:#1B1244;">开始测试</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="img/centrum/ysc/bg-img-1.png" class="circle-box-img-1" v-if="!isShowChange" />
                <img src="img/centrum/ysc/img-color-circle.png" class="circle-box-img-2" />
                <img src="img/centrum/ysc/bg-zoom.png" class="circle-box-img-3" v-if="!isShowChange" />
            </div>
            <div class="circle-box-otc">
                <img src="img/centrum/ysc/img-otc.png" class="imgs" />
                <div class="btn-weixin" v-show="isShowChange" @click="closeMoreInfo">
                    <div class="">
                        <div class="placeholder">

                            <div class="btn-wrapper"
                                style="width: 44vw; display: flex; align-items: center; justify-content: center;">
                                <!-- <img src="img/icon-back.png" style="height: 24px;width: 24px;position: relative;" alt="more-info"> -->
                                <span style="color:#1B1244;">返回</span>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="img/centrum/ysc/img-otc-txt.png" class="circle-box-otc-txt" v-if="!isShowChange" />

            </div>

            <!-- <div class="circle-box-bg">
                以下是科普，不代表产品<br />
                实际功效，请理性阅读
            </div> -->
        </div>
        <!-- <div :class="!isShowChange ? 'btn-box' : 'btn-box btn-show'">
            <div class="btn-weixin" ref="btn">
                <div class="" id="launch-btn">
                    <div class="placeholder">
                        <div class="btn-wrapper">
                            <span>开始测试</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->



        <centrum_ysc class="iframe-box" v-if="showIFrame"/>

        <div :class="!isShowTips ? 'info' : 'info move-down'">
            <div class="footer">
                <section>
                    <div class="btn-wrapper" @click="readMore">
                        <img src="img/btn-ysc-doc.png" alt="more-info">
                        <span>服用指南</span>
                    </div>
                    <div class="btn-wrapper" @click="onShowTips">
                        <img src="img/btn-ysc-test.png" alt="video">
                        <span>测一测</span>
                    </div>
                </section>

                <div class="tips">
                    <p>声明:产品识别存在误差，3D模型与扫描产品可能存在不一致，具体请以实物为准。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from 'vue';
import { getProductList, getMaterialType,productRecognition } from "@/api/service"
import { getAliyunSigned } from '@/api/service';
import centrum_ysc from './products/centrum/ysc.vue'
import { eventBus } from "@/utils/eventBus"
const showIFrameCloseBtn = ref(false);
const showIFrame = ref(false);
const showVideoInfo = ref(false)
const productList = ref(Array[Object])
const videoUrl = ref("")
const productName = ref("")
const series = ref("")
const btn = ref(null);
const isShowChange = ref(false);
const isShowTips = ref(false);

const onTap = async () =>{
    //alert(1)
}

const readMore = async () => {

    showIFrameCloseBtn.value = true;
    showIFrame.value = true;
    return;
}

const closeMoreInfo = () => {
    showIFrame.value = false;
    showIFrameCloseBtn.value = false
    isShowTips.value = false;
    isShowChange.value = false;
    eventBus.emit("show_model", "yes")
}

const onShowTips = () => {
    console.log('showTips')
    isShowTips.value = true;

    setTimeout(function () {
        isShowChange.value = true;
    }, 1500)
    eventBus.emit("hide_model", "yes")

};




const getProductInfo = () => {
    let id;
    let code = localStorage.getItem('model_name')
    for (let v of productList.value) {
        if (v.code === code) {
            id = v.id
            series.value = v.series
            productRecognitionData(id)
            break;
        }
    }

    return;

    getMaterialType(id).then(res => {
        if (res) {
            let list = res.items
            for (let v of list) {
                if (v.product_id == id) {
                    productName.value = v.product_name
                    videoUrl.value = v.content
                    productRecognitionData(v.product_id)
                    break;
                }
            }
        }
    })
}

const productRecognitionData = (product_id) => {
    productRecognition({product_id: product_id}).then(res=>{

    })
}


const init = () => {
    getProductList().then(res => {
        if (res) {
            productList.value = res
            getProductInfo()
        }
    })
    // //window.addEventListener('message', receiveMessage, false);
    eventBus.on('showCloseBtn', showCloseBtn)
    eventBus.on('hideCloseBtn', hideCloseBtn)
}

const showCloseBtn = () => {
    showIFrameCloseBtn.value = true;
}

const hideCloseBtn = () => {
    showIFrameCloseBtn.value = false;
}

const onTargetClick = () =>{
    closeMoreInfo();
}

const getWxConfig = () => {
    //获取阿里云签名
    getAliyunSigned().then(response => {
        if (response) {
            // localStorage.setItem('haleon_token', res.access_token)
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                appId: response.appId, // 必填，公众号的唯一标识
                nonceStr: response.nonceStr, // 必填，生成签名的随机串
                timestamp: response.timestamp, // 必填，生成签名的时间戳
                signature: response.signature,// 必填，签名
                jsApiList: ['chooseImage'], // 必填，需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
            });

            wx.ready(function () {
                // This will be called when the WeChat JS-SDK is ready
                console.log('ok')
                insertBtn();
            });
        }
    })
}


onMounted(() => {
    init();
    getWxConfig();

     eventBus.on('closeMoreInfo', closeMoreInfo)
});

const insertBtn = () => {
    if (btn.value) {
        btn.value.innerHTML = `<wx-open-launch-weapp
        id="launch-btn"
        username="gh_8089b73974a6"
        appid="wxb753e2045fe8a9f9"
        path="pages/index/index">
        <script type="text/wxtag-template">
          <style>
            .placeholder {
                 display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 32px;
                padding: 4px;
                height: 36px;
                font-weight: bold;
                color: #000;
            }

            .btn-wrapper {
                pointer-events: auto;
                display: flex;
                justify-content: space-around;
                align-items: center;
                color: #000;
                padding: .6rem 0;
                gap: 0 .6rem;
                height: 2rem;

                img {
                    width: 1.4rem;
                }
            }
          </style>

          <div class="placeholder">
                        <div class="btn-wrapper">
                            <span>开始测试</span>
                        </div>
                    </div>
        <\/script>
      </wx-open-launch-weapp>`;
    }
};

</script>

<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 100vh;
    z-index: 500;
    user-select: none;
    pointer-events: none;
    // background-image: url('/img/bg-sc.jpg') ;
    // background-size: cover;
    // background-repeat: no-repeat;

    .btn {
        padding: 0 2rem;
        border-radius: 26px;
        border-width: 0;
        color: white;
        background: linear-gradient(270deg, #23EAFB 0%, #0040D0 100%);
        text-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
        font-size: 1.5rem;
        letter-spacing: 1px;
        height: 40px;
        line-height: 40px;
        pointer-events: auto;
    }

    .half-font-size {
        font-size: .75rem;
        color: #efefef;
    }

    .info {
        width: 100%;
        height: 100%;
        max-width: 450px;
        min-width: 400px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: transparent;
        user-select: none;
        pointer-events: none;
        z-index: 400;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;


        .header {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .repair-list {
                margin-top: 1rem;
            }
        }

        .content {
            flex: 1;
            width: 100%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            //outline: 1px solid white;

            .center-tip {
                min-height: 40px;
                width: 80%;
                //outline: 1px solid deepskyblue;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                user-select: none;
                pointer-events: none;
                gap: 1rem 0;

                img {
                    padding-top: 40%;
                    width: 100%;
                    height: 100%;
                }

                span {
                    text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
                    font-weight: 500;
                    font-size: .8rem;
                    color: #EDEDED;
                }
            }

            .bottom-tip {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 80%;
                //outline: 1px solid black;
                position: absolute;
                bottom: 10%;
                left: 50%;
                transform: translateX(-50%);

                span {
                    font-size: .8rem;
                }

                span:nth-of-type(1) {
                    visibility: hidden;
                }

                span:nth-of-type(2) {
                    pointer-events: auto;
                }

                img {
                    vertical-align: -4px;
                }

            }
        }

        .footer {
            overflow: hidden;
            position: fixed;
            bottom: 60px;
            left: 0;
            height: 172px;
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;

            section:nth-of-type(1) {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 80%;

                .btn-wrapper {
                    background-image: url('/img/btn-centrum-ysc.jpg');
                    background-size: cover;
                    background-repeat: no-repeat;
                    border-radius: 32px;
                    width: 44%;
                    pointer-events: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: black;
                    padding: 4px;
                    gap: 0 10px;
                    height: 36px;
                    font-weight: bold;


                    img {
                        width: 22px;
                    }

                }
            }

            .tips {
                position: fixed;
                bottom: 40px;
                width: 100vw;
                font-size: 9px;
                color: #939393;
                pointer-events: auto;
                text-align: center;
            }
        }
    }

    .more-info {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: #000000;
        z-index: 500;
    }

}

@media screen and (orientation: landscape) {
    .container {
        width: 100vh;
        height: 100vw;
        transform-origin: left top;
        transform: rotate(-90deg) translateX(-100%);
    }
}

.btn-close {
    position: fixed;
    top: 14px;
    left: 6vw;
    z-index: 99999999;
    width: 12vw;
    height: 12vw;
    pointer-events: auto;
    color: #1B1244;
    font-size: 18px;
    font-weight: bold;
    background-image: url('/img/btn-centrum-ysc.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-close-2 {
    position: fixed;
    bottom: 10vh;
    width: 14vw;
    left: calc((100vw - 14vw) / 2);
    z-index: 999;
}

.iframe-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 997;
    background-color: #000000;
    border: 0;
    pointer-events: auto;
    overflow-y: scroll;
    top: 0;
}

.video-info {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000000;
    z-index: 500;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn-close {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1;
        width: 3rem;
    }
}

.video {
    width: 100vw;
    object-fit: contain;
}

.btn-weixin {
    pointer-events: auto;
    background-image: url(/img/btn-centrum-ysc.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 32px;
    width: 42vw;
    pointer-events: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    padding: 4px;
    gap: 0 10px;
    height: 44px;
    position: absolute;
    z-index: 99;
    font-size: 22px;
    top: calc(80vw * 0.5 - 46px / 2);
    left: calc((80vw - 44vw) / 2);
}


.btn-weixin-2 {
    pointer-events: auto;
    background-image: url(/img/btn-centrum-ysc.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 32px;
    width: 42vw;
    pointer-events: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    padding: 4px;
    gap: 0 10px;
    height: 44px;
    font-size: 22px;
    position: absolute;
    z-index: 999999;
    
}


/***ddddd */
.placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    padding: 4px;
    height: 36px;
    font-weight: bold;
    color: #000;
}

.btn-wrapper {
    pointer-events: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #000;
    padding: .6rem 0;
    gap: 0 .6rem;
    height: 2rem;

    img {
        width: 1.4rem;
    }
}




.btn-box {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 13.3vh;
    opacity: 0;
}


.move-down {
    animation: move-down 0.6s;
    animation-fill-mode: forwards;
}

@keyframes move-down {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        margin-top: 20vh;
    }
}


.move-up {
    animation: move-up 0.6s;
    animation-fill-mode: forwards;
}

@keyframes move-up {
    0% {
        margin-top: 24vh;
        opacity: 0;
    }

    100% {
        opacity: 1;
        margin-top: calc(100vw * 0.36);
        pointer-events: auto;
    }
}

.btn-show {
    animation: btn-show 0.8s;
    animation-fill-mode: forwards;
}

@keyframes btn-show {
    0% {
        bottom: 0vh;
        opacity: 0;
    }

    100% {
        opacity: 1;
        bottom: 22.3vh;
    }
}


.circle-box {
    width: 100vw;
    height: 100vw;
    border-radius: 50%;
    margin-top: 10vh;
    opacity: 0;



    .circle-box-bg {
        position: absolute;
        width: 100vw;
        height: 100vw;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 24px;
        top: 18px;
        opacity: 0.9;
        flex-wrap: wrap;
        background: repeating-linear-gradient(45deg, #130a24, #250d79);
    }

}

.circle-box-img {
    width: 100vw;
    height: calc(100vw * 1.13);
    position: relative;
    z-index: 2;
}

.circle-box-otc {
    width: 80vw;
    position: relative;
    z-index: 1;
    margin-top: -12vh;
    left: 10vw;

    img {
        width: 100%;
        position: absolute;
    }

    img.circle-box-otc-txt {
        width: 70vw;
        position: absolute;
        z-index: 1;
        top: 10vh;
        left: 20px
    }
}

.circle-box-img-1 {
    width: 100vw;
    position: absolute;
}

.circle-box-img-2 {
    width: 96vw;
    position: absolute;
    top: 26px;
    left: 10px;
    user-select: none;
    pointer-events: none;
}


.circle-box-img-3 {
    width: calc(100vw * 0.338);
    position: fixed;
    top: calc(100vw * 1.06);
    left: calc(100vw * 0.484);
}
</style>